function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function () { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*

  this is the main (and only) public entry point to the application from the browser
  debug, info, warn, error, and RequestLogger are exported for isomorphic
  compatibility with the nodejs entrypoiny (node.js)

*/

const BaseLogger = require('./logger');
const sanitize = require('./sanitize');
const constants = require('./constants');
const levels = require('./levels');

/**
 * The client cannot determine the app name or log level using configurator/configment right now it needs to be
 * set manually. In the case where it is not, we provide a sensible default.
 */

var configuration = {
  singletonConfig: {},
  get: function get() {
    return Object.assign({}, this.singletonConfig);
  },
  set: function set(config) {
    this.singletonConfig = Object.assign({}, config);
  },
  update: function update(config) {
    Object.assign(this.singletonConfig, config);
  },
  reset: function reset() {
    this.set({
      level: 'info',
      appName: 'adc'
    });
  }
};
configuration.reset();

/**
 * Styles we use to add minor style to browser console logging.
 */
const baseStyles = `
  color: #fff;
  text-transform: uppercase;
  padding: 3px 6px;
`.trim();
const levelStyles = {
  debug: `${baseStyles}
  background-color: ${constants.BROWSER_DEBUG_COLOR};
  `.trim(),
  info: `${baseStyles}
  background-color: ${constants.BROWSER_INFO_COLOR};
  `.trim(),
  warn: `${baseStyles}
  background-color: ${constants.BROWSER_WARN_COLOR};
  `.trim(),
  error: `${baseStyles}
  background-color: ${constants.BROWSER_ERROR_COLOR};
  `.trim(),
  alert: `${baseStyles}
  background-color: ${constants.BROWSER_ERROR_COLOR};
  `.trim()
};
let BrowserLogger = /*#__PURE__*/function (_BaseLogger) {
  "use strict";

  _inherits(BrowserLogger, _BaseLogger);
  var _super = _createSuper(BrowserLogger);
  function BrowserLogger() {
    _classCallCheck(this, BrowserLogger);
    return _super.apply(this, arguments);
  }
  _createClass(BrowserLogger, [{
    key: "fromCurrentFunction",
    value: function fromCurrentFunction() {
      return this;
    }
  }, {
    key: "_logAtLevel",
    value: function _logAtLevel(level, ...messages) {
      const appName = configuration.get().appName;
      let loggerPrefix = null;
      if (messages.length > 1 && messages[0].startsWith(constants.LOGGER_REFERENCE_PREFIX)) {
        loggerPrefix = messages[0].replace(constants.LOGGER_REFERENCE_PREFIX, '').replace(constants.LOGGER_REFERENCE_SUFFIX, '').trim();
        messages = messages.slice(1);
      }
      messages = messages.map(arg => sanitize(arg));
      if (levels[level] >= levels[configuration.get().level]) {
        // eslint-disable-next-line no-console
        console.log(`%c${loggerPrefix || appName}`, levelStyles[level], ...messages);
      }
    }
  }], [{
    key: "forModule",
    value: function forModule(modReference) {
      return new BrowserLogger(modReference);
    }
  }]);
  return BrowserLogger;
}(BaseLogger);
function RequestLogger() {
  this.logger = BrowserLogger.forModule('RequestLogger');
  this.request = this.response = function (...args) {
    this.logger.info(...args); // eslint-disable-line no-console
  };
}

/**
 * Match the Isomorphic API
 */
BrowserLogger.prototype.RequestLogger = RequestLogger;
BrowserLogger.prototype.configuration = configuration;

// Wish we could use Reflection for this but our apps don't have this rule enabled in babel...
BrowserLogger.prototype.forModule = BrowserLogger.forModule;
module.exports = new BrowserLogger();